/** Company identity, tax details, address and the brand colour. */
import { useApp } from '../../store/AppContext.jsx';
import { BRANDS } from '../../constants/defaults.js';
import { Section, Grid, Row, TextField, SelectField, NumberField } from './SettingsBits.jsx';

export default function OrgPane() {
  const { S, patchSettings, toast } = useApp();
  const brand = S.brand || BRANDS[0];

  return (
    <>
      <Section title="Organisation">
        <Grid>
          <TextField label="Trading name" name="companyName" />
          <TextField label="Legal name" name="legalName" />
          <TextField label="Trade licence no." name="licence" />
          <TextField label="TRN / VAT number" name="trn" />
          <NumberField label="VAT rate" name="vat" unit="percent" min={0} max={30} />
          <TextField label="Currency" name="currency" />
          <TextField label="City / Emirate" name="city" />
          <TextField label="Country" name="country" />
          <TextField label="Support email" name="supportEmail" />
          <TextField label="Website" name="website" />
          <SelectField
            label="Financial year starts"
            name="fyStart"
            options={['January', 'April', 'July', 'October']}
          />
          <TextField label="Workspace name" name="workspace" hint="shown in the sidebar" />
        </Grid>
      </Section>

      <Section title="Address">
        <TextField name="address" area />
      </Section>

      <Section title="Brand colour" hint="Applies across buttons, highlights and charts.">
        <Row>
          {BRANDS.map(b => (
            <button
              type="button"
              key={b[0]}
              className={`btn${brand[0] === b[0] ? ' soft' : ''}`}
              onClick={() => { patchSettings({ brand: b }); toast('Brand colour applied'); }}
            >
              <span
                style={{
                  width: 14,
                  height: 14,
                  borderRadius: 5,
                  display: 'inline-block',
                  background: `linear-gradient(135deg,${b[0]},${b[1]})`
                }}
              />
              {b[2]}
            </button>
          ))}
        </Row>
      </Section>
    </>
  );
}
